import CoStagesAPI from "@/api/CoStagesAPI";
import {idUserForApi, typesContact} from "@/controllers/UserController";
import store from "@/store";
import {returnErrorsForSumData} from "@/helpers/coMappers";

class CoStagesController {
  constructor() {
    this.api = CoStagesAPI;
  }


  _checkTypeContact(typeContact) {
    if (!typesContact[typeContact])
      throw new Error('type contact invalid can be founder or region;');
  }

  _checkId(id) {
    if (!id)
      throw new Error('id cannot be null');
  }

  /**
   * @param {Number} kcpGroupId
   * @param {1 | 2 | 3} foId
   * @param { Number | null | undefined } [founderId]
   * */
  async getDataStage(kcpGroupId, foId = 1, founderId) {
    try {
      founderId = founderId ?? idUserForApi(founderId);
      this._checkId(founderId);
      const res = await this.api.getDataStage(kcpGroupId, foId, founderId);
      return res.data
    } catch (e) {
      console.error('error getDataStage ' + e.message)
      throw new Error('error getDataStage ' + e.message)
    }
  }

  /**
   * @param {Number} rowId
   * @param {1 | 3} stageId
   * @param {Number | string} value
   * @param {string} textVal
   * @param {Number | null} offerId
   * */
  async saveDataOffer(rowId = null, stageId = 1, value = null, offerId, textVal = '') {
    try {
      if (!rowId || !value)
        throw new Error('rowId && value invalid; cannot be null');
      const payload = {
        id: offerId ?? 0,
        "stageDataId": rowId,
        "value": Number.parseInt(value),
        "comment": textVal,
        "founder": {
          "id": store.getters['keycloak/getAuthData']?.founderID ?? store.getters['keycloak/getFakeUser']?.id,
        },
        stageId: stageId
      }
      const res = await this.api.saveDataOffer(payload);
      return res.data
    } catch (e) {
      console.error('error saveDataOffer ' + e.message)
      throw new Error('error saveDataOffer ' + e.message)
    }
  }

  /**
   * @param {Number} kcpGroupId
   * @param { Number | null | undefined } [founderId]
   * */
  async getDataStageThreeSumsForKcp(kcpGroupId, founderId) {
    try {
      founderId = founderId ?? idUserForApi(founderId);
      this._checkId(founderId);
      const res = await this.api.getDataStageThreeSumsForKcp(kcpGroupId, founderId);
      return {
        ...res.data,
        errors: returnErrorsForSumData(res.data)
      }
    } catch (e) {
      console.error('error getDataStageThreeSumsForKcp ' + e.message)
      throw new Error('error getDataStageThreeSumsForKcp ' + e.message)
    }
  }

  //getDataById
  /**
   * @param {Number} stageDataId
   * */

  async getCoDataById(stageDataId) {
    try {
      const res = await this.api.getDataById(stageDataId);
      return res.data
    } catch (e) {
      console.error('error getDataStageThreeSumsForKcp ' + e.message)
      throw new Error('error getDataStageThreeSumsForKcp ' + e.message)
    }
  }

}

export default new CoStagesController();